import { FileText, KeyRound, ListChecks, ClipboardCheck, Siren } from "lucide-react";

const tone = { red: "text-alert", amber: "text-[#B87300] dark:text-[#FFA000]", green: "text-health", muted: "text-muted-foreground" };

const Chip = ({ n, label, t, testid }) => (
  <span className={`text-xs ${n ? tone[t] : tone.muted}`} data-testid={testid}><b className="font-mono">{n}</b> {label}</span>
);

export const statTiles = (s) => [
  ["Documents", FileText, s.documents.total, [[s.documents.drafts, "drafts", "amber"], [s.documents.under_review, "in review", "amber"], [s.documents.approved, "approved", "green"]]],
  ["Live permits", KeyRound, s.permits.live, [[s.permits.suspended, "suspended", "red"], [s.permits.awaiting, "awaiting sign-off", "amber"], [s.permits.drafts, "drafts", "muted"]]],
  ["Open actions", ListChecks, s.actions.open, [[s.actions.overdue, "overdue", "red"], [s.actions.awaiting_verification, "to verify", "amber"], [s.actions.from_incidents || 0, "from incidents", "muted"]]],
  ["Inspections", ClipboardCheck, s.inspections.total, [[s.inspections.in_progress, "in progress", "amber"]]],
  ["Incidents", Siren, s.incidents?.total || 0, [[s.incidents?.open || 0, "open", "red"]]],
];

export const ProjectStats = ({ s, compact }) => (
  <div className={`grid gap-3 ${compact ? "grid-cols-2" : "grid-cols-2 lg:grid-cols-5"}`} data-testid="project-stats">
    {statTiles(s).map(([label, Icon, big, chips]) => (
      <div key={label} className={`rounded-xl border ${compact ? "bg-muted/30 p-3" : "bg-card p-4"}`}>
        <p className="flex items-center gap-1.5 text-xs text-muted-foreground"><Icon className="h-3.5 w-3.5" />{label}</p>
        <p className={`mt-1 font-display font-bold ${compact ? "text-xl" : "text-3xl"}`} data-testid={`stat-${label.toLowerCase().replace(" ", "-")}`}>{big}</p>
        <div className="mt-1 flex flex-wrap gap-x-2">{chips.map(([n, l, t]) => <Chip key={l} n={n} label={l} t={t} testid={`stat-${label.toLowerCase().replace(" ", "-")}-${l.replace(" ", "-")}`} />)}</div>
      </div>
    ))}
  </div>
);

export const attention = (s) => s.actions.overdue * 3 + s.permits.suspended * 3 + s.documents.under_review + s.documents.drafts + s.permits.awaiting;
